import React from 'react';
import { Button, Link, Tooltip, makeStyles } from '@fluentui/react-components';
import { CopyRegular, CheckmarkRegular } from '@fluentui/react-icons';
import { SUPPORT_EMAIL, buildAccessRequestUrl } from '../constants/support';

const useStyles = makeStyles({
  wrapper: {
    whiteSpace: 'nowrap',
  },
  button: {
    minWidth: 'auto',
    height: 'auto',
    padding: '0',
    verticalAlign: 'text-bottom',
    marginLeft: '4px',
  },
});

const CopyEmailButton: React.FC<{ className: string }> = ({ className }) => {
  const [copied, setCopied] = React.useState(false);
  const label = copied ? 'Copied' : 'Copy email address';

  React.useEffect(() => {
    if (!copied) return;
    const timer = window.setTimeout(() => setCopied(false), 2000);
    return () => window.clearTimeout(timer);
  }, [copied]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(SUPPORT_EMAIL);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  return (
    <Tooltip content={label} relationship="label" withArrow>
      <Button
        appearance="transparent"
        size="small"
        className={className}
        aria-label={label}
        icon={copied ? <CheckmarkRegular /> : <CopyRegular />}
        onClick={copy}
      />
    </Tooltip>
  );
};

interface SupportEmailProps {
  subject?: string;
}

export const SupportEmail: React.FC<SupportEmailProps> = ({ subject }) => {
  const styles = useStyles();

  return (
    <span className={styles.wrapper}>
      <Link href={buildAccessRequestUrl(subject)} target="_blank" rel="noopener noreferrer">
        {SUPPORT_EMAIL}
      </Link>
      <CopyEmailButton className={styles.button} />
    </span>
  );
};
